export const TAB_IDS = {
  DASHBOARD: "dashboard",
  REQUESTS: "requests",
  SETTINGS: "settings"
};
